import { alpha, styled } from "@mui/material/styles";

import { Menu, MenuItem } from "@mui/material";

import Iconify from "src/components/Iconify";

import { useTranslation } from "react-i18next";
import Translate from "src/components/translate";
import useQueryParams from "src/hooks/useQueryParams";
import status from "./_status";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const StatusMenu = ({ anchorEl, onClose }) => {
  const { addParam } = useQueryParams();
  const { t } = useTranslation();
  const test = (value, name) => () => {
    addParam({ update_to: value, name: t(name) });
    onClose();
  };

  return (
    <StyledMenu
      id="demo-status-menu"
      MenuListProps={{
        "aria-labelledby": "demo-status-button",
      }}
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
    >
      {status.map(({ value, name, icon }) => (
        <MenuItem onClick={test(value, name)} disableRipple>
          <Iconify icon={icon} />
          &nbsp; <Translate>{name}</Translate>
        </MenuItem>
      ))}
    </StyledMenu>
  );
};

export default StatusMenu;
